/**
 * Copyright ©2024 Drivepoint
 */

import {Config} from "@bainbridge-growth/node-frontend";
import Firebase from "./Firebase.ts";
import WebAppServerError from "../errors/WebAppServerError.ts";

export default class WebAppServerClient {

  static async getStandardOptions(method: string, body?: any): Promise<any> {
    let type = "application/json";
    if (body != null) {
      if (body instanceof Blob) {
        type = body.type;
      } else {
        body = typeof body === "string" ? body : JSON.stringify(body);
      }
    }
    return {
      headers: {
        "x-drivepoint-frontend": "drivepoint-excel-add-in",
        "Content-Type": type,
        "Authorization": Firebase.bearer
      },
      method: method,
      body: body
    };
  }

  // Matches Cloud Run's default request timeout. The previous 60s ceiling was
  // shorter than several legitimate server operations (notably the v2
  // applyToPlans endpoint, which writes the full GL pivot to SharePoint via
  // Microsoft Graph) and caused the client to abort while the server was
  // still happily completing the work.
  private static DEFAULT_TIMEOUT_MS = 10 * 60_000;

  static async request(path: string, method: string, body?: any, abortController?: AbortController, timeoutMs?: number): Promise<any> {
    const options = await this.getStandardOptions(method, body);
    options.signal = abortController?.signal ?? AbortSignal.timeout(timeoutMs ?? WebAppServerClient.DEFAULT_TIMEOUT_MS);
    const response = await fetch(`${Config.get("server.api.url", window.location.origin)}${path}`, options);
    const contentType = response.headers.get("Content-Type") ?? "";
    const data = contentType.includes("application/json") ? response.json() : response.blob();
    if (response.status > 399) { throw new WebAppServerError(response.statusText, path, await data, response.status); }
    return data;
  }

}
